
export type Student = {
  first: string;
  last: string;
  initial: string;

}

export const DEFAULT_STUDENT: Student = {first: "No Candidate Selected", last: "", initial: ""}


export const CANDIDATES: Student[] = [
    
    {
      first: "Fred",
      last: "Flintstone",
      initial: "F"
    },
    {
      first: "Barney",
      last: "Rubble",
      initial: "B"
    },
    {
   first: "Xavier",
   last: "Aguilar",
   initial: "X"
 },
 {
   first: "Adam",
   last: "Anderson",
   initial: "A"
 },
 {
   first: "Carter",
   last: "Averill",
   initial: "C"
 },
 {
   first: "Hector",
   last: "Avila Cruz",
   initial: "H"
 },
 {
   first: "Cassie",
   last: "Brady",
   initial: "C"
 },
 {
   first: "Jake",
   last: "Brady",
   initial: "J"
 },
 {
   first: "Esme",
   last: "Carreon",
   initial: "E"
 },
 {
   first: "Jacob",
   last: "Carrigg",
   initial: "J"
 },
 {
   first: "Patty",
   last: "Clark",
   initial: "P"
 },
 {
   first: "Brenda",
   last: "Duran",
   initial: "B"
 },
 {
   first: "Raul",
   last: "Flores Martinez",
   initial: "R"
 },
 {
   first: "Vivaldi",
   last: "Franco",
   initial: "V"
 },
 {
   first: "Robert",
   last: "Heaton",
   initial: "R"
 },
 {
   first: "Mady",
   last: "Herrera",
   initial: "M"
 },
 {
   first: "Blake",
   last: "Johnson",
   initial: "B"
 },
 {
   first: "Stephanie",
   last: "Juarez ",
   initial: "S"
 },
 {
   first: "Erik",
   last: "Klosterman",
   initial: "E"
 },
 {
   first: "Toni",
   last: "Klosterman",
   initial: "T"
 },
 {
   first: "Marco",
   last: "Langarica",
   initial: "M"
 },
 {
   first: "Anna",
   last: "LaRosa",
   initial: "A"
 },
 {
   first: "Ethan",
   last: "Leishman",
   initial: "E"
 },
 {
   first: "Raymundo",
   last: "Lopez",
   initial: "R"
 },
 {
   first: "Sam",
   last: "Matthews ",
   initial: "S"
 },
 {
   first: "Rickey",
   last: "Maze",
   initial: "R"
 },
 {
   first: "Shannon",
   last: "McAfee",
   initial: "S"
 },
 {
   first: "Khalil",
   last: "McNulty ",
   initial: "K"
 },
 {
   first: "Aaron",
   last: "Meyrovich",
   initial: "A"
 },
 {
   first: "Bianka",
   last: "Mier",
   initial: "B"
 },
 {
   first: "Irene",
   last: "Mier",
   initial: "I"
 },
 {
   first: "Victoria",
   last: "Montoya",
   initial: "V"
 },
 {
   first: "Estrellita",
   last: "Morales",
   initial: "E"
 },
 {
   first: "Mark",
   last: "Mourton II",
   initial: "M"
 },
 {
   first: "Elyse",
   last: "Mull",
   initial: "E"
 },
 {
   first: "Wyatt",
   last: "Mull",
   initial: "W"
 },
 {
   first: "Jolette",
   last: "Nieves",
   initial: "J"
 },
 {
   first: "Julian",
   last: "Padilla",
   initial: "J"
 },
 {
   first: "Isaiah",
   last: "Perez",
   initial: "I"
 },
 {
   first: "Amanda",
   last: "Peterson",
   initial: "A"
 },
 {
   first: "Quinn",
   last: "Poll",
   initial: "Q"
 },
 {
   first: "Deborah",
   last: "Powers",
   initial: "D"
 },
 {
   first: "Ron",
   last: "Proffit",
   initial: "R"
 },
 {
   first: "Lara",
   last: "Proffit ",
   initial: "L"
 },
 {
   first: "Jenna",
   last: "Rapattoni",
   initial: "J"
 },
 {
   first: "Tylie",
   last: "Roman",
   initial: "T"
 },
 {
   first: "Julia",
   last: "Ruiz",
   initial: "J"
 },
 {
   first: "Justin",
   last: "Salas",
   initial: "J"
 },
 {
   first: "Bree",
   last: "Schmit",
   initial: "B"
 },
 {
   first: "Jeremy",
   last: "Schmit",
   initial: "J"
 },
 {
   first: "David",
   last: "Schwartz",
   initial: "D"
 },
 {
   first: "Lyndsay",
   last: "Smith",
   initial: "L"
 },
 {
   first: "Devona",
   last: "Tafalla",
   initial: "D"
 },
 {
   first: "Ernie",
   last: "Tafalla",
   initial: "E"
 },
 {
   first: "Daniel",
   last: "Thompson",
   initial: "D"
 },
 {
   first: "Liberty",
   last: "Thompson",
   initial: "L"
 },
 {
   first: "Jacob",
   last: "Torres",
   initial: "J"
 },
 {
   first: "Abimael",
   last: "Vazquez",
   initial: "A"
 },
 {
   first: "Victor",
   last: "Vazquez",
   initial: "V"
 },
 {
   first: "Jason",
   last: "Verity",
   initial: "J"
 },
 {
   first: "Chris",
   last: "Watt",
   initial: "C"
 },
 {
   first: "Joe",
   last: "Weitz",
   initial: "J"
 },
 {
   first: "Kristen",
   last: "Weitz",
   initial: "K"
 },
 {
   first: "Maryrose",
   last: "Willadsen",
   initial: "M"
 },
 {
   first: "James",
   last: "Woodley",
   initial: "J"
 },
 {
   first: "James",
   last: "Woodley II",
   initial: "Jr"
 },
 {
   first: "Cameron",
   last: "Wylie",
   initial: "C"
 },
 {
   first: "Megan",
   last: "Zaragoza",
   initial: "Z"
 },
 {
   first: "Joylyn",
   last: "Zetz",
   initial: "J"
 }
];